import React from "react";
import VowGame from "pages/game/vow/VowGame";

const SimplifiedGame: React.FC = () => {
  return <VowGame />;
};

export default SimplifiedGame;
